export default __webpack_public_path__ + "static/media/logo.f337af68.png";